var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMj30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -1.27,
    y: 1.41,
    width: 34.28,
    height: 31.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -1.27,
    y: 1.41,
    width: 34.61,
    height: 32.02
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.21,6.73h-3.94v-3.31h2.21c.41,0,.75-.34.75-.75s-.34-.75-.75-.75h-11.02c-.41,0-.75.34-.75.75s.34.75.75.75h2.21v3.31H.79c-.41,0-.75.34-.75.75v19.85c0,.41.34.75.75.75h28.42c.41,0,.75-.34.75-.75V7.48c0-.41-.34-.75-.75-.75Zm-9.05-3.31h3.6v3.31h-3.6v-3.31Zm8.3,23.16H1.54V8.23h26.92v18.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m.69,20.7c1.98-.03,3.61-2.44,4.78-2.44,1.41,0,1.57,2.65,3.42,2.65s1.85-2.65,3.26-2.65.73,2.65,2.65,2.65,1.89-2.65,3.3-2.65,1.66,2.65,2.96,2.65,1.95-2.65,3.2-2.65,1.03,2.66,4.83,2.65v6.42H.69v-6.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMj30);
export default __webpack_public_path__ + "static/media/MJ30.b628b271e754d88cdc9c951e081ef266.svg";
export { ForwardRef as ReactComponent };